const ugr = 'UniqGrow';
export default ugr;
